<template>
  <div class="news_box">
    <!-- 评论盒子 -->
    <comment-box
      v-model="comment_show"
      v-if="comment_show"
      :item-id="item_id"
      :parmas-data="comment_parmas"
      @getCommentTxt="getCommentTxt"
      @close="close"
    />

    <van-tabbar :fixed="false" v-model="active" @change="changeNav">
      <van-tabbar-item>
        <span>@我的</span>
        <template #icon="props">
          <img :src="props.active ? icon.active : icon.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item icon="chat-o">评论</van-tabbar-item>
      <van-tabbar-item icon="good-job-o">点赞</van-tabbar-item>
    </van-tabbar>
    <div class="comtent_box">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" description="暂无消息" />
        <van-list
          v-else
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="(item, index) in list" :key="index">
            <div class="aite_item">
              <div class="user_info">
                <!-- @我的 -->
                <div v-if="active === 0">
                  <div
                    class="user_avatar"
                    :style="{
                      background:
                        'url(' + item[item.type].user.avatar + ') no-repeat',
                      backgroundSize: '100% 100%'
                    }"
                  ></div>
                  <div @click="sendComment(item)" class="user_name">
                    {{ item[item.type].user.nickname }}：&nbsp;
                    {{
                      item[item.type].content || item[item.type].short_content
                    }}
                  </div>
                  <p style="clear: both;"></p>
                </div>

                <!-- 评论 -->
                <div v-if="active === 1">
                  <div
                    class="user_avatar"
                    :style="{
                      background:
                        'url(' + item.comment.user.avatar + ') no-repeat',
                      backgroundSize: '100% 100%'
                    }"
                  ></div>
                  <div @click="sendComment(item)" class="user_name">
                    {{ item.comment.user.nickname }}：&nbsp;
                    {{ item.comment.content }}
                  </div>
                  <div class="posts_info">
                    <p>评论我的帖子：{{ item.comment.item.short_content }}</p>
                  </div>
                  <p style="clear: both;"></p>
                </div>

                <!-- 点赞 -->
                <div v-if="active === 2">
                  <div
                    class="user_avatar"
                    :style="{
                      background: 'url(' + item.user.avatar + ') no-repeat',
                      backgroundSize: '100% 100%'
                    }"
                  ></div>
                  <div @click="sendComment(item)" class="user_name">
                    {{ item.user.nickname }}：&nbsp; 赞了我的{{
                      item.type === "item" ? "帖子" : "评论"
                    }}
                  </div>
                  <div class="posts_info">
                    <p>
                      {{
                        item[item.type].short_content || item[item.type].content
                      }}
                    </p>
                  </div>
                  <p style="clear: both;"></p>
                </div>

                <div class="right_box">
                  <span @click="sendComment(item)" class="comment_span">
                    <i class="comment_icon"></i>
                    回复
                  </span>
                  &nbsp;|
                  <span @click="sendLike(item)" class="like_span">
                    <i
                      v-if="active === 1"
                      :class="{
                        like_icon: true,
                        is_like: item.comment.is_like
                      }"
                    ></i>

                    <i
                      v-else
                      :class="{
                        like_icon: true,
                        is_like: item[item.type].is_like
                      }"
                    ></i>
                    赞
                  </span>
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  Tabbar,
  TabbarItem,
  List,
  PullRefresh,
  Cell,
  Empty,
  Toast
} from "vant";

import {
  getMyAiteInfoApi,
  getMyCommentInfoApi,
  getMyLikeInfoApi
} from "@/api/news";

import { likesPostsApi, cancelLikesPostsApi } from "@/api/home";

import { commentsLikeApi, cancelCommentsLikeApi } from "@/api/info";

export default {
  name: "home",
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
    [Empty.name]: Empty,
    [Toast.name]: Toast,
    commentBox: () => import("../components/commen-box")
  },
  data() {
    return {
      active: 0, // 标签导航下标
      icon: {
        active:
          "https://statics.spyouxi.com/uploads/2021/10-19/624b91231bd3678a.png",
        inactive:
          "https://statics.spyouxi.com/uploads/2021/10-19/97183cb20cc23c3d.png"
      },
      list: [], // 数据
      loading: false,
      finished: false,
      refreshing: false,
      comment_show: false,
      item_id: "",
      comment_parmas: {
        reply_user_id: 0,
        reply_comment_id: 0,
        top_comment_id: 0
      }, //
      page: 1
    };
  },

  methods: {
    // 切换标签
    changeNav() {
      this.list = [];
      this.onRefresh();
    },

    // 加载数据
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }

      // 根据所选下标获取数据
      if (this.active === 0) {
        // 获取艾特我的数据列表
        getMyAiteInfoApi().then(res => {
          this.getDataSucceed(res.data, res.data.ats);
        });
      } else if (this.active === 1) {
        // 获取评论我的数据列表
        getMyCommentInfoApi().then(res => {
          this.getDataSucceed(res.data, res.data.comments);
        });
      } else {
        // 获取点赞我的数据列表
        getMyLikeInfoApi().then(res => {
          this.getDataSucceed(res.data, res.data.likes);
        });
      }
    },

    // 点击点赞
    sendLike(item) {
      if (this.active === 1) {
        // 评论点赞
        this.commentLike(item);
      } else {
        this.infoLike(item);
      }
    },

    // 评论点赞
    commentLike(item) {
      if (!item.is_like) {
        commentsLikeApi(item.id, item.comment.id).then(() => {
          item.is_like = true;
        });
      } else {
        cancelCommentsLikeApi(item.id, item.comment.id).then(() => {
          item.is_like = false;
        });
      }
    },

    // 其他消息点赞
    infoLike(item) {
      if (!item[item.type].is_like) {
        likesPostsApi(item[item.type].id).then(() => {
          item[item.type].is_like = true;
        });
      } else {
        cancelLikesPostsApi(item[item.type].id).then(() => {
          item[item.type].is_like = false;
        });
      }
    },

    // 点击评论
    sendComment(item) {
      this.item_id = item.id;
      if (this.active !== 1) {
        this.comment_parmas.reply_user_id = item.user
          ? item.user.id
          : item[item.type].user.id;
        console.log(this.comment_parmas, "this.comment_parmas");
      } else {
        this.comment_parmas.reply_user_id = item.comment.user.id;
        this.comment_parmas.reply_comment_id = item.comment.id;
        this.comment_parmas.top_comment_id = item.comment.item.id;
      }
      this.comment_show = true;
    },

    // 获取数据成功后,
    getDataSucceed(res, list) {
      if (res.has_more) {
        this.list = this.list.concat(res.items);
        this.page++;
      } else {
        this.list = list;
        this.finished = true;
      }
      this.loading = false;
    },

    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },

    // 更新评论内容
    getCommentTxt(res) {
      if (res) {
        Toast.success("操作成功！");
        // 刷新列表
        this.list = [];
        this.onRefresh();
      }
      this.close();
    },

    // 关闭评论盒子
    close() {
      this.comment_show = false;
    }
  }
};
</script>

<style scoped>
.news_box {
  width: 100%;
}

.comtent_box {
  width: 100%;
  padding: 3vw 5vw;
}
@import "../assets/my_info.css";
</style>
